import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { AvailabilityCalendarLabels, AvailabilityCalendarView } from './types'
import {
  CurrentDateLabel,
  NavButton,
  NavGroup,
  TodayButton,
  Toolbar,
  ToolbarCenter,
  ToolbarLeft,
  ViewButton,
  ViewButtons,
} from './style'

interface CalendarToolbarProps {
  labels: AvailabilityCalendarLabels
  view: AvailabilityCalendarView
  dateLabel: string
  onNavigate: (direction: -1 | 1) => void
  onToday: () => void
  onViewChange: (view: AvailabilityCalendarView) => void
}

export const CalendarToolbar = ({
  labels,
  view,
  dateLabel,
  onNavigate,
  onToday,
  onViewChange,
}: CalendarToolbarProps): JSX.Element => (
  <Toolbar>
    <ToolbarLeft>
      <NavGroup>
        <NavButton type="button" aria-label={labels.previous} onClick={() => onNavigate(-1)}>
          ‹
        </NavButton>
        <TodayButton type="button" onClick={onToday}>
          {labels.today}
        </TodayButton>
        <NavButton type="button" aria-label={labels.next} onClick={() => onNavigate(1)}>
          ›
        </NavButton>
      </NavGroup>
      <ToolbarCenter>
        <FontAwesomeIcon icon={faCalendar} fontSize={16} color="var(--text-primary)" />
        <CurrentDateLabel>{dateLabel}</CurrentDateLabel>
      </ToolbarCenter>
    </ToolbarLeft>

    <ViewButtons>
      <ViewButton
        type="button"
        $active={view === 'month'}
        onClick={() => onViewChange('month')}
      >
        {labels.month}
      </ViewButton>
      <ViewButton
        type="button"
        $active={view === 'week'}
        onClick={() => onViewChange('week')}
      >
        {labels.week}
      </ViewButton>
      <ViewButton
        type="button"
        $active={view === 'day'}
        onClick={() => onViewChange('day')}
      >
        {labels.day}
      </ViewButton>
    </ViewButtons>
  </Toolbar>
)
